module.exports = __webpack_public_path__ + "img/cardClear.a29b9cc9.svg";